/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

// Module to make the google api injectable.
angular.module('googleModule', [])
.factory('google', ['$window', google]);

function google($window) {
  return $window.gapi || {};
}
